<template>
  <div class="app-container">
    <el-row type="flex" class="row-bg">
      <el-col :span="8" class="flex">
        <span>省份</span>
        <el-select class="sel-box" v-model="search.sfenid" @change="provinceChangeFun" placeholder="请选择省份" clearable>
          <el-option v-for="item in provinceList" :key="item.sfid" :label="item.sfen" :value="item.sfid"
            style="width:100%">
          </el-option>
        </el-select>
      </el-col>

      <!-- <el-col :span="8" class="flex">
        <span>城市</span>
        <el-select
					v-model="search.cityId"
					placeholder="请选择"
					clearable
					style="width: 100%"
					:disabled="!search.sfenid"
				>
					<el-option
						v-for="item in cityList"
						:key="item.ciid"
            :label="item.city"
            :value="item.ciid"
						style="width: 100%"
					>
					</el-option>
				</el-select>
      </el-col> -->

      <el-col :span="8" class="flex">
        <span>回收类型（大类）</span>
        <el-select class="sel-box" v-model="search.spid" placeholder="请选择类型" clearable>
          <el-option v-for="item in goodsTypeList" :key="item.value" :label="item.spmc" :value="item.spid"
            style="width:100%">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="flex">
        <el-button type="primary" size="medium" @click="searchBtnFun">查询</el-button>
        <el-button size="medium" @click="resetBtnFun">重置</el-button>
      </el-col>
    </el-row>
    <div class="m-b-10">
      <el-button type="primary" size="medium" @click="createActualPriceBtnFun">创建实际价格</el-button>
      <el-button type="primary" size="medium" @click="createMoreActualPriceBtnFun">批量创建实际价格</el-button>
    </div>
    <el-table :data="tableDataList" @selection-change="handleSelectionChange" :reserve-selection="true" height="60vh">
      <el-table-column type="selection" min-width="50" align="center">
      </el-table-column>
      <el-table-column prop="sfenid" label="省份编号" min-width="120" align="center"></el-table-column>
      <el-table-column prop="sfen" label="省份名称" min-width="100" align="center"></el-table-column>
      <!-- <el-table-column prop="city" label="城市" min-width="100" align="center"></el-table-column> -->
      <el-table-column prop="spmc" label="回收类型(大类)" min-width="100" align="center"></el-table-column>
      <el-table-column prop="xlmc" label="回收类型(小类)" min-width="100" align="center"></el-table-column>
      <el-table-column prop="xhmc" label="规格" min-width="100" align="center"></el-table-column>
      <el-table-column prop="brandStr" label="品牌" min-width="100" align="center"></el-table-column>
      <el-table-column prop="pipeStr" label="是否含管" min-width="100" align="center"></el-table-column>
      <el-table-column prop="paneStr" label="单双片" min-width="100" align="center"></el-table-column>
      <el-table-column prop="ageStr" label="年限" min-width="100" align="center"></el-table-column>
      <el-table-column prop="price" label="回收价格" min-width="100" align="center"></el-table-column>
      <el-table-column prop="unitStr" label="单位" min-width="100" align="center"></el-table-column>
      <el-table-column label="操作" fixed="right" width="150" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="editRow(scope.row)">编辑</el-button>
          <el-button type="text" @click="deleteRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper" :current-page.sync="search.pageNum"
        :page-size.sync="search.pageSize" :page-sizes="[10, 20]" :total="total">
      </el-pagination>
    </div>
    <AddActualPriceDialog ref="addActualPriceDialogRef" :provinceList="provinceList" :dlList="goodsTypeList"
      @opera-success="getList"></AddActualPriceDialog>
    <BatchAddActualPriceDialog ref="batchAddActualPriceDialogRef" @opera-success="getList"></BatchAddActualPriceDialog>
  </div>
</template>
<script>
import AddActualPriceDialog from './component/AddActualPriceDialog.vue'
import BatchAddActualPriceDialog from './component/BatchAddActualPriceDialog.vue'
export default {
  name: 'actualPriceRecovery',
  components: {
    AddActualPriceDialog,
    BatchAddActualPriceDialog
  },
  data () {
    return {
      /**
       * total 表格总数
       * search 查询参数
       *  pageNum 页码
       *  pageSize 页数量
       *  sfenid 省份id
       *  spid 回收类别id
       * tableDataList 表格数据
       * provinceList 省份选择列表
       * goodsTypeList 回收类别选择列表
       */
      total: 0,
      search: {
        pageNum: 1,
        pageSize: 10,
        sfenid: '',
        spid: '',
        cityId: ''
      },
      tableDataList: [],
      provinceList: [],
      goodsTypeList: [],
      cityList: [],
    }
  },
  created () {
    this.initGetData()
  },
  methods: {
    initGetData () {
      this.getTblProvince()
      this.getgoodsTypeList()
      this.getList()
    },
    // 查询
    searchBtnFun () {
      this.search.pageNum = 1
      this.getList()
    },
    // 重置查询
    resetBtnFun () {
      this.search = {
        pageNum: 1,
        pageSize: 10,
        sfenid: '',
        spid: '',
      }
      this.getList()
    },
    // 创建实际价格
    createActualPriceBtnFun () {
      this.$refs.addActualPriceDialogRef.openDialog()
    },
    // 批量创建实际价格
    createMoreActualPriceBtnFun () {
      this.$refs.batchAddActualPriceDialogRef.openDialog()
    },
    // 选择表格改变
    handleSelectionChange () {
      console.log('选择表格改变')
    },
    // 当前页数量改变
    handleSizeChange () {
      this.getList()
    },
    // 当前页数改变
    handleCurrentChange () {
      this.getList()
    },
    // 获取表格数据列表
    getList () {
      this.tableDataList = []
      this.HttpService.post('/autoapp-default-server-recovery/api/tbl-actual-price-control/page', this.search).then(res => {
        if (res.statusCode === 200) {
          this.total = res.total || 0
          const resData = res.data
          if (resData && resData.length === 0) {
            this.$dialog({
              title: '温馨提示',
              content: '未查询到结果!',
              footBtn: false,
              width: '20%',
              dialogType: 'sighicon',
            })
          } else {
            this.tableDataList = resData.records || []
          }
        }
      })
    },
    // 获取省份列表
    getTblProvince () {
      return this.HttpService.get('/autoapp-default-server-recovery/api/tbl-province/getTblProvince').then(res => {
        if (res.statusCode === 200) {
          this.provinceList = res.data
        }
      })
    },
    // 获取回收类别 flag是否有效 1 有效 2 无效 3 有闲有品
    getgoodsTypeList () {
      // let params = {
      //   flag: 1
      // }
      return this.HttpService.get('/autoapp-default-server-recovery/api/tbl-splb-dalei/getTblSplbDalei?flag=3').then(res => {
        if (res.statusCode === 200) {
          this.goodsTypeList = res.data
        }
      })
    },
    // 编辑表格行数据
    editRow (row) {
      console.log('edit====row====', row)
      this.$refs.addActualPriceDialogRef.openDialog('edit', row)
    },
    // 删除行
    deleteRow (row) {
      const id = row.id
      if (id) {
        this.$dialog({
          title: '温馨提示',
          content: '是否要删除，删除后不可以恢复！',
          cancel_buttton: '否',
          ok_buttton: '是',
          width: '400px',
          footBtn: 'card',
          dialogType: 'delete',
          onOk: () => {
            const idList = [id]
            this.HttpService.delete(`/autoapp-default-server-recovery/api/tbl-actual-price-control/deleteByIds?idList=${idList}`, {}).then(res => {
              if (res.statusCode === 200) {
                this.$message.success('删除成功')
                this.getList()
              } else {
                const tipMsg = res.message || '操作失败'
                this.$message.error(tipMsg)
              }
            })
          },
          onCancel: () => {
            console.log('cancel');
          }
        })
      }
    },
    // 省份改变
    provinceChangeFun (value) {
      this.search.cityId = undefined
      const sfenObj = this.provinceList.find(item => item.sfid === value)
      const sfenName = sfenObj ? sfenObj.sfen : ''
      if (sfenName) {
        this.getCityList(sfenName)
      }
    },
    // 获取城市列表
    getCityList(provinceName) {
			const url = `/autoapp-default-server-recovery/api/tbl-city/getTblCity?sfen=${provinceName}`
			return this.HttpService.get(url).then(res => {
				if (res.statusCode === 200) {
					this.cityList = res.data || []
				}
			})
		},
  }
}
</script>


<style scoped lang="scss">
.flex {
  display: flex;
  align-items: center;
  padding: 0px 0px 0px 20px;

  span {
    display: inline-block;
    min-width: 80px;
    max-width: 160px;
    width: auto;
    padding-right: 15px;
    box-sizing: border-box;
  }

  .sel-box {
    flex-grow: 2;
  }
}

.row-bg {
  margin-bottom: 15px;
}

.dialog {

  .dialog-footer {
    padding: 20px 60px;
  }
}

.tree {
  max-height: 200px;
  overflow: auto;
  border-radius: 3px;
  border: 1px solid #C0C4CC;
}
</style>



// WEBPACK FOOTER //
// src/views/recoveryManagement/actualPriceRecovery.vue